import { BooleanField, CreateButton, Datagrid, DateField, ImageField, List, NumberField, TextField, TopToolbar } from 'react-admin';
import { useLocation } from 'react-router-dom';

const PodcastList = () => {
	const location = useLocation();
	const isGlobalFromQuery = new URLSearchParams(location.search).get('is_global') === 'true';
	return (
		<List
			resource="podcasts/all"
			filter={isGlobalFromQuery ? { is_global: true } : undefined}
			sort={{ field: 'date', order: 'DESC' }}
			actions={
				<TopToolbar>
					<CreateButton resource="podcasts" />
				</TopToolbar>
			}
		>
			<Datagrid rowClick="edit" resource="podcasts">
				<ImageField source="thumbnailUrl" label="תמונה" />
				<TextField source="title" label="שם" />
				<TextField source="sub_title" label="תת כותרת" />
				<NumberField source="duration" label="אורך (שניות)" />
				<BooleanField source="visible" label="זמין" />
				<BooleanField source="is_global" label="גלובלי" />
				<TextField source="audioUrl" label="קובץ" />
				<DateField source="date" label="תאריך" />
			</Datagrid>
		</List>
	);
};

export default PodcastList;
